import apiClient from '../apiClient';

/**
 * Search for aliases by customer and optional filters
 * @param {string} customerId - Customer ID to filter by
 * @param {string} fieldKey - Optional field key filter
 * @param {string} searchTerm - Optional search term for original or replacement values
 * @returns {Promise} API response with aliases
 */
export const searchAliases = (customerId, fieldKey = null, searchTerm = null) => {
  const params = new URLSearchParams({ customerId });
  
  if (fieldKey) {
    params.append('fieldKey', fieldKey);
  }
  
  if (searchTerm) {
    params.append('searchTerm', searchTerm);
  }
  
  return apiClient.get(`/aliases?${params.toString()}`);
};

/**
 * Create a manual alias
 * @param {Object} aliasData - Alias creation data
 * @returns {Promise} API response with created alias
 */
export const createAlias = (aliasData) => {
  return apiClient.post('/aliases', aliasData);
};

/**
 * Update an alias
 * @param {number} aliasId - Alias ID to update
 * @param {Object} updateData - Update data containing replacementValue
 * @returns {Promise} API response
 */
export const updateAlias = (aliasId, updateData) => {
  return apiClient.put(`/aliases/${aliasId}`, updateData);
};

/**
 * Deactivate an alias
 * @param {number} aliasId - Alias ID to deactivate
 * @returns {Promise} API response
 */
export const deactivateAlias = (aliasId) => {
  return apiClient.put(`/aliases/${aliasId}/deactivate`);
};

/**
 * Export aliases to JSON
 * @param {string} customerId - Customer ID to filter by
 * @param {string} fieldKey - Optional field key filter
 * @returns {Promise} API response with JSON file
 */
export const exportAliases = (customerId, fieldKey = null) => {
  const params = new URLSearchParams({ customerId });
  
  if (fieldKey) {
    params.append('fieldKey', fieldKey);
  }
  
  return apiClient.get(`/aliases/export?${params.toString()}`, {
    responseType: 'blob'
  });
};
